( function () {
	'use strict';

	function templateRevisionModalCtrl ( modalInstance, templateRevisionModalModel ) {
		var self = this;

		self.model                = templateRevisionModalModel;
		self.model.confirmAndSave = function () {
			localStorage.setItem( self.model.identifier, self.modalFlag );
			( self.model.confirm || angular.noop )();
		};

		function genericHandler ( type ) {
			return function () {
				( self.model[ type ] || angular.noop )();
				modalInstance.dismiss();
			};
		}

		self.cancelModal  = genericHandler( 'cancel' );
		self.confirmModal = genericHandler( 'confirmAndSave' );
	}

	templateRevisionModalCtrl.$inject = [ '$modalInstance', 'templateRevisionModalModel' ];

	angular
		.module( 'app.templates' )
		.controller( 'templateRevisionModalCtrl', templateRevisionModalCtrl );
} )();
